module.exports = __webpack_public_path__ + "img/frame_issue_titlebg.30c5f0b9.png";